class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector('[data-toggle-checkbox]');
    this.hiddenControlField = this.querySelector(`[data-hidden-control]`);
    this.inputFields = this.querySelectorAll('[data-input-field]');
    this.requiredInputFields = this.querySelectorAll('[data-required-input-field]');
    this.datePicker = this.querySelector('[data-date-input-field]');

    this.checkboxInput.disabled = false;
    this.hiddenControlField.disabled = true;
    this.datePicker.min = new Date().toISOString().split("T")[0];

    this.checkboxInput.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    this.classList.toggle('open', this.checkboxInput.checked);
    this.fieldAreRequired(this.checkboxInput.checked)

    if (!this.checkboxInput.checked) {
      this.clearInputFields();
    }
  }

  clearInputFields() {
    this.inputFields.forEach((field) => field.value = '');
  }

  fieldAreRequired(state) {
    this.requiredInputFields.forEach((field) => field.required = state);
  }
}

try {
  customElements.define('recipient-form', RecipientForm);
}
catch(e) {}
